import { Grid2, Typography } from "@mui/material";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";


// return array data to render form fields

export const GroupCard = ( data, index, multiple, sectionTitle ) => {
  return data?.array?.map(
    ( {
      id,
      name,
      title,
      value,
      options,
      defaultValue,
      place_holder,
      required,
      type,
      error,
      handleFunction,
      errorText,
      width,
      disabled,
      Component,
      endIcon,
      startIcon,
      dynamicDate
    } ) => {
      return (
        <Grid2 size={ 2 }>
          <Component
            rowId={ data?.id }
            id={ id }
            name={ name }
            title={ title }
            type={ type }
            value={ value }
            defaultValue={ defaultValue }
            width={ width }
            handleFunction={ handleFunction }
            error={ error }
            options={ options }
            helper_text={ error && errorText }
            place_holder={ place_holder }
            required={ required }
            multiple={ multiple }
            sectionTitle={ sectionTitle }
            disabled={ disabled }
            endIcon={ endIcon }
            startIcon={ startIcon }
            dynamicDate={ dynamicDate }
          />
        </Grid2>
      );
    }
  );
};

// return heading

export const Heading = ( { title, variant, color, align, handleToggleExpand, isExpanded, expand } ) => {
  return (
    <div style={ { textAlign: align } }>
      { expand && (
        <div role="button" onClick={ handleToggleExpand } style={ { cursor: 'pointer', fontSize: '32px', width: '100%', textAlign: 'start',  padding: '2px', width: "35px", height: '35px', display: 'flex', justifyContent: 'center', alignItems: 'center' } }>
          { isExpanded ? <PlusOutlined style={ { fontSize: '16px' } } /> : <MinusOutlined style={ { fontSize: '16px' } } /> }
        </div>
      ) }
      <Typography variant={ variant } color={ color } margin="12px 4px">
        { title }
      </Typography>
    </div>
  );
};
